import React from 'react'

const Footer = () => {
  return (
    <div className=' w-full  flex flex-col md:flex-row justify-between items-center shadow-xl   px-[3%] py-10 '>
      <div className='mb-5 md:mb-0'>
          <h6 className='opacity-50'>© Copyright all reserved Turkuaz Medical</h6>
      </div>
      <div className='flex flex-col md:flex-row  md:space-x-20 '>
        <div className='flex justify-center space-x-1 mb-5 md:mb-0'>
            <a target='_blank' href=''><img src='/images/footer/i.svg' className='h-10 hover:scale-105 transition-all duration-300 cursor-pointer'/></a>
            <a target='_blank' href=''><img src='/images/footer/li.svg'  className='h-10 hover:scale-105 transition-all duration-300 cursor-pointer'/></a>
        </div>
        {/* <div>
        <a target='_blank' href='https://www.zeybekciholding.com/index.html'><img src='/images/footer/zeybekci-logo.svg' className='h-10 hover:scale-105 transition-all duration-300 cursor-pointer'/></a>
        </div> */}
      </div>

    </div>
  )
}

export default Footer